import React from "react";
import Button from "antd/lib/button";

const MobileTabBar = ({
  hasResults = false,
  selectedTab = "Input",
  selectedCount,
  onTabClick = () => alert("onTabClick is not being passed to the MobileTabBar")
}) => {
  const isResultsTabDisabled = !hasResults;
  const outputHeading = selectedCount
    ? `Output (${selectedCount}/30)`
    : "Output";
  const inputTabClassName = selectedTab === "Input" ? "activeTab" : null;
  const resultsTabClassName = selectedTab === "Results" ? "activeTab" : null;
  const outputTabClassName = selectedTab === "Output" ? "activeTab" : null;
  return (
    <div className="TabBar">
      <Button.Group size="large">
        <Button
          className={inputTabClassName}
          onClick={() => onTabClick("Input")}
        >
          Inputs
        </Button>
        <Button
          className={resultsTabClassName}
          disabled={isResultsTabDisabled}
          onClick={() => onTabClick("Results")}
        >
          Results
        </Button>
        <Button
          className={outputTabClassName}
          disabled={isResultsTabDisabled}
          onClick={() => onTabClick("Output")}
        >
          {outputHeading}
        </Button>
      </Button.Group>
    </div>
  );
};

export default MobileTabBar;



// WEBPACK FOOTER //
// ./src/MobileTabBar.js